
import { PredefinedOptionType, PredefinedPreSupportOptions, SystemEvent } from '@/common/bot/enum';
import { BaseSystemMessage, PreSupportSelectionEvent } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import LikeIcon from '@/components/icons/LikeIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FaAngleRight,
    CustomerSupportIcon,
    LikeIcon,
  },
})
export default class PreSupportConfirmation extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  buildEvent (selected: PredefinedPreSupportOptions) {
    const event: PreSupportSelectionEvent = {
      type: SystemEvent.PRE_SUPPORT_SELECTION,
      message: this.message,
      payload: { selected },
    };

    this.$emit('send:event', event);
  }
}
